export class PackingSlipDetailDto {
  orderDetailId = 0;
  productId = 0;
  shipQuantity = 0;
  backorderQuantity = 0;
}
